export enum RegionFeatureOverrideAbility {
  OVERRIDABLE     = 'OVERRIDABLE',
  NOT_OVERRIDABLE = 'NOT_OVERRIDABLE',
}
